var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{ mobile: _vm.onMobile },attrs:{"id":"nav"}},[(_vm.$route.name == 'Home')?_c('main-menu'):_c('loner-menu')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }